(function () {
  var menu = document.querySelector('.ib-menu');
  if (!menu) return;

  function close() {
    menu.removeAttribute('open');
  }

  menu.addEventListener('click', function (event) {
    if (event.target.closest('a')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  document.addEventListener('click', function (event) {
    if (menu.hasAttribute('open') && !menu.contains(event.target)) close();
  });
})();
